import * as Sentry from '@sentry/react';

export const initLogging = Sentry.init;

export const httpClientIntegration = Sentry.httpClientIntegration();

export const thirdPartyErrorFilterIntegration =
  Sentry.thirdPartyErrorFilterIntegration({
    filterKeys: ['betty-web-app'],
    behaviour: 'drop-error-if-contains-third-party-frames',
  });

export const navigationIntegration = {
  registerNavigationContainer: () => null,
};

export const setUser = (id: string) => {
  Sentry.setUser({ id });
};

export const setContext = Sentry.setContext;

export const logHttpRequest = (finalUrl: string, request: RequestInit) => {
  if (!__DEV__) {
    Sentry.addBreadcrumb({
      category: 'http',
      message: `Request: ${request.method} ${finalUrl}`,
      level: 'info',
    });
  }
};

export const logHttpResponse = (response: Response) => {
  if (!__DEV__) {
    Sentry.addBreadcrumb({
      category: 'http',
      message: `Response: ${response.url} ${response.status} ${response.headers.get('x-correlation-id')}`,
      level: 'info',
    });
  }
};

export const logInfo = (
  context = 'App',
  message?: string | number,
  ...args: unknown[]
) => {
  if (__DEV__) {
    // eslint-disable-next-line no-console
    console.log(`[${context}]:`, message, ...args);
  } else if (context !== 'Response' && context !== 'Request') {
    Sentry.addBreadcrumb({
      category: context,
      message: `${message}`,
      level: 'info',
      data: args,
    });
  }
};

export function logError(
  errorType: string,
  errorData: unknown,
  extraContext?: Record<string, unknown>,
) {
  Sentry.withScope((scope) => {
    scope.setTag('errorType', errorType);

    let errorToCapture: Error;

    if (errorData instanceof Error) {
      errorToCapture = errorData;
    } else {
      errorToCapture = new Error(errorType);
      if (typeof errorData === 'object' && errorData !== null) {
        scope.setContext('originalPayloadString', {
          data: JSON.stringify(errorData),
        });
        scope.setContext(
          'originalPayload',
          errorData as Record<string, unknown>,
        );
      }
    }

    if (extraContext) {
      scope.setContext('extraContext', extraContext);
    }

    if (__DEV__) {
      console.error(errorType, errorToCapture, extraContext);
    } else {
      Sentry.captureException(errorToCapture, {
        contexts: {
          errorContext: {
            type: errorType,
          },
        },
      });
    }
  });
}
